import React, { useEffect, useRef, useState } from 'react';

import { Slide, Tooltip, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';

import dropDownArrow from '../../public/assets/arrowDown.svg';
import hamburger from '../../public/assets/burger.svg';
import xicon from '../../public/assets/close.svg';
import fileverseLogo from '../../public/assets/mainLogo.svg';
import whiteArrow from '../../public/assets/whiteArrow.svg';
import HeartBitBanner from '../Banner/Banner';

const NewNavbar = () => {
  const [menu, setMenu] = useState(false);
  const [top, setTop] = useState(true);
  const isMediaMax1025px = useMediaQuery('(max-width: 1025px)');
  const [sideMenu, setSideMenu] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const router = useRouter();
  const ref: any = useRef(null);
  const hamburgerbar: any = useRef(null);
  const dropDownButton: any = useRef(null);
  const html = typeof window !== 'undefined' && document.querySelector('html');
  const isIPFSExplorerPage = router.pathname === '/ipfs';

  const handleScroll = () => {
    if (window.scrollY === 0) {
      setTop(true);
    } else {
      setTop(false);
    }
  };
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (isMediaMax1025px) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          sideMenu &&
          !hamburgerbar.current?.contains(event.target)
        ) {
          setSideMenu(false);
          if (html) html.classList.remove('overflow-y-hidden');
        }
      } else if (
        dropDownButton.current &&
        !dropDownButton.current.contains(event.target) &&
        menu
      ) {
        setMenu(false);
      }
    }
    document.addEventListener('click', handleClickOutside);
  });
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });
  useEffect(() => {
    setTimeout(() => {
      setShowBanner(true);
    }, 2000);
  }, []);
  return (
    <div
      className={`flex bg-white fixed w-[100vw] min-h-[10vh] justify-center z-50 flex-col gap-4`}
    >
      {showBanner && isIPFSExplorerPage && <HeartBitBanner />}
      <div className={`w-[90%] flex`}>
        <div
          className={` lg:w-[50%] ${
            isMediaMax1025px && 'w-full'
          } duration-500 ease-in-out transitio bg-white flex items-center`}
          onClick={() => router.push('/ipfs')}
        >
          <img
            className={`${
              isMediaMax1025px && 'h-8 w-8'
            } cursor-pointer lg:h-12 lg:w-12 mr-2`}
            alt="fileverse-logo"
            src={fileverseLogo.src}
          />
          <span
            className={` cursor-pointer font-xx ${
              isMediaMax1025px && 'text-xs'
            }`}
          >
            Fileverse
          </span>
        </div>
        <div
          className={`
            lg:w-[50%] duration-500 ease-in-out transition relative flex bg-white items-center h-full justify-end`}
          ref={dropDownButton}
        >
          {isMediaMax1025px ? (
            <div
              ref={hamburgerbar}
              onClick={() => {
                if (html) html.classList.add('overflow-y-hidden');
                setSideMenu(!sideMenu);
              }}
            >
              <img src={hamburger.src} alt="hamburger" />
            </div>
          ) : (
            <button
              onClick={() => setMenu(!menu)}
              className={`border rounded-md ${
                top ? 'bg-black text-white ' : 'bg-white'
              } flex transition duration-500 ease-in-out p-4 w-[12rem] justify-center h-[3rem] items-center border-black`}
            >
              <p className="mr-4">About</p>
              {top ? (
                <Image
                  className={` ${menu ? 'rotate-[-90deg]' : ' rotate-90'}`}
                  alt="white-dropdown-arrow"
                  src={whiteArrow.src}
                  width="16"
                  height="16"
                />
              ) : (
                <Image
                  className={`w-4 h-4 ${menu ? 'rotate-[-180deg]' : ''}`}
                  src={dropDownArrow.src}
                  alt="black-dropdown-arrow"
                  width={'16'}
                  height={'16'}
                />
              )}
            </button>
          )}

          <Slide direction="down" in={menu} container={dropDownButton.current}>
            <div
              className={`absolute py-4 rounded-lg w-[12rem] -z-[999999] shadow-lg bg-white top-[80px]`}
            >
              <a
                href={'https://beta.fileverse.io/'}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-[34px] hover:cursor-pointer  items-center mx-[12px] px-2 py-4 border-fade border-bottom border-b"
              >
                Fileverse Solo
              </a>

              <Tooltip title="Coming Soon" placement="right">
                <div className="h-[34px] cursor-not-allowed flex text-gray-400 items-center mx-[12px] px-2 py-4 border-fade border-bottom border-b ">
                  Fileverse Portal
                </div>
              </Tooltip>

              <a
                target="_blank"
                href={'https://fileverse.io/'}
                className="h-[34px] hover:cursor-pointer flex items-center mx-[12px] px-2 py-4 border-fade border-bottom border-b"
                rel="noreferrer"
              >
                Learn More
              </a>

              <a
                target="_blank"
                href={'https://twitter.com/fileverse'}
                className="h-[34px] hover:cursor-pointer flex items-center mx-[12px] px-2 py-4 border-fade border-bottom"
                rel="noreferrer"
              >
                Follow Fileverse
              </a>
            </div>
          </Slide>
        </div>
      </div>
      <Slide direction="left" in={sideMenu}>
        <div
          ref={ref}
          className="h-[100vh] shadow-lg right-0 bg-white p-4 absolute w-[60vw]"
        >
          <div
            onClick={() => {
              if (html) html.classList.remove('overflow-y-hidden');
              setSideMenu(false);
            }}
            className="w-full flex justify-end text-3xl"
          >
            <img src={xicon.src} className="w-8" alt="x-icon" />
          </div>
          <div className="flex flex-col">
            <a
              href={'https://beta.fileverse.io'}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                if (html) html.classList.remove('overflow-y-hidden');
                setSideMenu(false);
              }}
              className="py-2"
            >
              Fileverse Solo
            </a>

            <Tooltip title="Coming Soon" placement="right">
              <div className="cursor-not-allowed text-gray-400 py-2">
                Fileverse Portal
              </div>
            </Tooltip>

            <a
              target="_blank"
              href={'https://fileverse.io/'}
              className="py-2"
              rel="noreferrer"
            >
              Learn More
            </a>

            <a
              target="_blank"
              href={'https://twitter.com/fileverse'}
              className="py-2"
              rel="noreferrer"
            >
              Follow Fileverse
            </a>
          </div>
        </div>
      </Slide>
    </div>
  );
};

export default NewNavbar;
